<template>
  <transition name="modal-fade">
    <div id="modalEditBanner" class="dibble-modal">
      <div class="modal small-m">
        <div
          class="modal-dialog modal-form "
          role="document"
          style="width: 400px"
        >
          <div class="modal-content">
            <div class="modal-header">
              <p class="title-modal">{{title}}</p>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                @click="closeModal"
              >
              <img src="../../../assets/images/close-dialog.svg" alt="close-icon">
              </button>
            </div>
            <div class="modal-body form-box mt-2">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  name: "ModalAddNote",
	props: {
		title: {
			type: String,
		}
	},
  data() {
    return {
      mode: "add",
      data: null,
      serial: "",
      newNote: "",
    };
  },
  created() {},
  methods: {
    closeModal() {
      this.newNote = "";
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
	.modal-content {
		min-width: 500px !important;
	}
	.modal-content, .modal-body {
		background: #C2D8DD !important;
		border-radius: 60px !important;
		padding: 10px 20px;
	}
	.modal-header {
		display: flex !important;
		justify-content: space-between !important;
		align-items: center;
		padding: 10px 0px !important;
		border-bottom: 1.5px solid #1C5169;
		margin: 0 20px !important;
		.title-modal {
			font-family: 'Open Sans';
			font-style: normal;
			font-weight: 700;
			font-size: 22px;
			line-height: 22px;
			letter-spacing: 0.01em;
			color: #1C5169;
			margin-top: 0 !important;
		}
		button {
			border: none !important;
			outline: none !important;
			background: initial;
		}
	}
</style>
